/**
 * Created by bootdo.
 */
import axios from 'axios'
import Cookies from 'js-cookie'
import {
  bus
} from '../bus.js'
axios.defaults.withCredentials = false;
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
//  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';//配置请求头

let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { //当当前请求在数组中存在时执行函数体
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //把这条记录从数组中移除
    }
  }
}

//添加一个请求拦截器
axios.interceptors.request.use(
  config => {
    config.headers.appId = process.env.appId;
    // config.headers.appId = '9e45e6f90a1342c896c2a87ca945063a';
    if (Cookies.get('token')) {
      config.headers.Authorization = Cookies.get('token');
      // config.headers.Authorization = 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxMzEwOTk4NjczMCIsImNvbnRleHRVc2VySWQiOiI5ZDcwYzZjYjBkNzE0OTUxOWY0NTcxZjE0M2UyNGQyNCIsImNvbnRleHROYW1lIjoiMTMxMDk5ODY3MzAiLCJjb250ZXh0RGVwdElkIjoiMSIsImNvbnRleHRBcHBsaWNhdGlvbklkIjoiMzBiMGY0N2MyYzAwNDNjNmIwYmUwZjIwMGRlMTA3YzMiLCJjb250ZXh0VXNlcm5hbWUiOiIxMzEwOTk4NjczMCIsImNvbnRleHRSZWFsTmFtZSI6IiIsImNvbnRleHRBcHBJZCI6IjMwYjBmNDdjMmMwMDQzYzZiMGJlMGYyMDBkZTEwN2MzIiwiZXhwIjozMjg1MzI2MzUxN30.4N4NYhexAZMGE8il4Ar6BVc7yf1BnFbfxbS63NTBnyE'
    } else {
      //登陆跳转
      bus.$emit('login', '/login');
    }
    return config;
  },
  error => {
    return Promise.reject(error)
  }
);
// 添加一个响应拦截器
axios.interceptors.response.use(function (response) {
  if (response.data && response.data.code) {
    if (parseInt(response.data.code) === 401 || parseInt(response.data.code) === 403) {
      //未登录
      bus.$emit('login', '/login')
    }
  }
  return response;
}, function (error) {
  // Do something with response error
  return Promise.reject(error);
});


//通用方法
export const POST = (url, params) => {
  return axios.post(`${url}`, params)
    .then(res => res.data)
};

//通过params字符串拼接
export const POSTURL = (url, params) => {
  url += "?"
  for (var key in params) {
    url += key + "=" + params[key] + "&"
  }
  return axios({
    method: 'post',
    url: `${url}`,
    data: {},
    responseType: 'blob'
  }).then(res => res.data)
};

//test
export const POSTUP = (url, params) => {
  return axios({
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    url: `${url}`,
    data: params
  }).then(res => res.data)
};



export const GET = (url, params) => {
  return axios.get(`${url}`, {
    params: params
  }).then(res => res.data)
};

export const GETblob = (url, params) => {
  return axios({
    method: 'get',
    url: `${url}`,
    params: params,
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'blob'
  })
};

export const POSTBLOB = (url, params) => {
  return axios({
    method: 'post',
    url: `${url}`,
    data: params,
    responseType: 'blob'
  }).then(res => res.data)
};

export const POSTBLOBOri = (url, params) => {
  return axios({
    method: 'post',
    url: `${url}`,
    data: params,
    responseType: 'blob'
  }).then(res => res)
};

export const GETBLOB = (url, params) => {
  return axios.get(`${url}`, {
    params: params,
    responseType: 'blob'
  }).then(res => res.data)
};
export const GET2 = (url, params) => {
  return axios.get(`${url}`, {
    params: params
  }).then(res => res.data)
};

export const PUT = (url, params) => {
  return axios.put(`${url}`, params).then(res => res.data)
};

export const DELETE = (url, params) => {
  return axios.delete(`${url}`, {
    params: params
  }).then(res => res.data)
};

export const PATCH = (url, params) => {
  return axios.patch(`${url}`, params).then(res => res.data)
};



// WEBPACK FOOTER //
// ./src/api/index.js